export default "__VITE_ASSET__apluqADF__"